export type PaymentResponse =
  | { status: 'failed' }
  | { status: 'succeeded'; invoiceId: string }
  | { status: 'requires_action'; clientSecret: string };
